module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"capitalGrowthTable":"Capital Growth"},"si":{"capitalGrowthTable":"Capital Growth"},"ta":{"capitalGrowthTable":"Capital Growth"}}')
  delete Component.options._Ctor
}
